<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
    <div class="notice_dialog" v-if="show">
      <div class="notice_content">
        <div style="position: relative">
          <img class="closebtn" @click="next_()" :src="$common.imageRoot + '/closebtn.png'" alt="" />
          <h1 class="notice_title">{{ content.title }}</h1>
          <section class="content" v-html="content.content"></section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isRouterAlive: true,
      content: { title: "", content: "" },
      items: [],
      show: false,
      currentIndex: 0,
      client_currency: "",
      isPrepaidRecharge: "",
    };
  },
  watch: {
    $route(n, o) {
      this.client_currency = this.$common.getUserInfoFromStorage("client_currency");
      this.isPrepaidRecharge = this.$common.getUserInfoFromStorage("is_prepaid_recharge");
    },
  },
  created() {
    // this.isLogining();
    this.$APIPHP.getSysNotice().then((res) => {
      if (res.code == 1) {
        if (res.data.length > 0) {
          this.items = res.data;
          let timer = localStorage.getItem("timeper");
          if (timer) {
            if (Date.parse(new Date()) > timer) {
              // 超过了24小时 出现弹窗
              this.show = true;
              this.showDialog();
            }
          } else {
            this.show = true;
            this.showDialog();
          }
        }
      } else {
        this.$message({
          showClose: true,
          message: res.msg,
          type: "error",
        });
      }
    });
  },
  mounted() {
    this.client_currency = this.$common.getUserInfoFromStorage("client_currency");
    this.isPrepaidRecharge = this.$common.getUserInfoFromStorage("is_prepaid_recharge");
  },
  methods: {
    isLogining() {
      let token = this.$cookies.get("hotpots_token_from_rocket");
      if (token) {
        this.$APIPHP
          .getUserInfoByPandahotspot()
          .then((res) => {
            if (res.code == 1) {
              let data = res.data;
              localStorage.setItem("userinfo", JSON.stringify(data));
              localStorage.setItem(
                "setCompanyState",
                JSON.stringify({
                  status: data.client_company_status,
                  remark: data.client_remark,
                  source: data.source,
                })
              );
              localStorage.setItem("setIsPerfect", data.is_perfect);
              this.$store.commit("setCompanyState", {
                status: data.client_company_status,
                remark: data.client_remark,
                source: data.source,
              });
              this.$store.commit("setIsPerfect", data.is_perfect);
              let is_prepaid_recharge = "";
              if (data.is_prepaid_recharge) {
                is_prepaid_recharge = data.is_prepaid_recharge;
              }
              this.$store.commit("SET_IS_PREPAID_RECHARGE", is_prepaid_recharge);
              this.$APIPHP.searchOptions().then((res) => {
                if (res.code == 1) {
                  localStorage.setItem("configurationData", JSON.stringify(res.data));
                }
              });
              this.$router.push("/index");
            } else {
              this.$message({ message: res.msg, type: "error" });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        localStorage.clear();
        this.$common.clearCookies();
        this.$router.push("/login");
      }
    },
    next_() {
      if (this.currentIndex == this.items.length) {
        this.show = false;
        localStorage.setItem("timeper", Date.parse(new Date()) + 24 * 60 * 60 * 1000);
        this.currentIndex = 0;
      } else {
        this.content = this.items[this.currentIndex++];
      }
    },
    showDialog() {
      this.currentIndex = 0;
      this.content = this.items[0];
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
  },
  provide() {
    return {
      reload: this.reload,
      _app: this,
    };
  },
};
</script>

<style lang="scss">
.notice_dialog {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
  z-index: 10;
  .notice_content {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 900px;
    height: 550px;
    border-radius: 5px;
    background: url("#{$image-root}/modelBg_.png") no-repeat center top;
    .notice_title {
      font-size: 40px;
      font-weight: bold;
      text-align: center;
      margin: 60px 0;
      color: #fff;
    }
    .content {
      white-space: pre-wrap;
      margin: 0px 50px;
      padding-top: 30px;
      color: #333;
      max-height: 340px;
      overflow-y: scroll;
      p {
        line-height: 28px;
      }
    }
    .closebtn {
      position: absolute;
      right: -70px;
      top: -60px;
      cursor: pointer;
    }
  }
}
</style>
